import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import css from './download-button.scss';
import DownloadIcon from './assets/download-icon.svg';

const DownloadButton = (props) => {
    const { disabled, title = '', isDownloading, onClick } = props;

    if (disabled || isDownloading) {
        return (
            <div className={css.buttonDisabled}>
                <div className={css.dash} />
            </div>
        );
    }

    return (
        <div
            className={css.button}
            onClick={onClick}
            role="button"
            tabIndex={0}
        >
            <span className={css.title}>{title}</span>
            <Isvg width={'12px'} src={DownloadIcon} cacheGetRequests />
        </div>
    );
};

DownloadButton.propTypes = {
    disabled: PropTypes.bool,
    title: PropTypes.string,
    isDownloading: PropTypes.bool,
    onClick: PropTypes.func.isRequired
};

export default styleable(css)(DownloadButton);



// WEBPACK FOOTER //
// ./components/certificates/components/download-button/download-button.js